import { ISession } from '../models/session.model';

/**
 * La única cuenta de la demo.
 *
 * Está a la vista a propósito, igual que el resto de `data/`: este tablero no
 * tiene backend ni base de datos, así que la comprobación ocurre en el navegador
 * y cualquiera puede leerla en el bundle. Esconderla daría una falsa sensación
 * de seguridad; lo honesto es que se vea que es una demo.
 *
 * Aquí NO se pone nada que no pueda ser público.
 */
export const CUENTA_DEMO: { readonly correo: string; readonly contrasena: string } = {
  correo: 'desarrollo@cleversec.com.mx',
  contrasena: '123456',
};

/** Sesión que queda abierta tras entrar. */
export const SESION_DEMO: ISession = {
  correo: CUENTA_DEMO.correo,
};
